import { render, staticRenderFns } from "./FatalIndicator.vue?vue&type=template&id=32745ba8&scoped=true&"
import script from "./FatalIndicator.vue?vue&type=script&lang=ts&"
export * from "./FatalIndicator.vue?vue&type=script&lang=ts&"
import style0 from "./FatalIndicator.vue?vue&type=style&index=0&id=32745ba8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32745ba8",
  null
  
)

export default component.exports